"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilPackageFunctionSignal = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const z = __importStar(require("zod"));
const merge_values_js_1 = require("../utils/merge-values.js");
const hilPackageFunctionSignalSchema = z.object({
    optional: z.boolean().nullable().default(null),
    isMultiAssignment: z.boolean().nullable().default(null),
    busType: z.nativeEnum(sigma_engine_shared_1.ComponentFunctionBusType).nullable().default(null),
    signalTypes: z.nativeEnum(sigma_engine_shared_1.SignalDirection).array().nullable().default(null),
    signalIds: z.union([z.string(), z.number()]).array().default([]),
    description: z.string().nullable().default(null),
    classSignalDescription: z.string().nullable().default(null),
    alternateNames: z.string().array().nullable().default(null),
    maxAssignments: z.number().nullable().default(null),
});
const hilPackageFunctionSignalDtoSchema = z.object({
    optional: z.boolean().nullable().optional(),
    isMultiAssignment: z.boolean().nullable().optional(),
    busType: z.nativeEnum(sigma_engine_shared_1.ComponentFunctionBusType).nullable().optional(),
    signalTypes: z.nativeEnum(sigma_engine_shared_1.SignalDirection).array().nullable().optional(),
    signalIds: z.union([z.string(), z.number()]).array().optional(),
    description: z.string().nullable().optional(),
    classSignalDescription: z.string().nullable().optional(),
    alternateNames: z.string().array().nullable().optional(),
    maxAssignments: z.number().nullable().optional(),
});
exports.HilPackageFunctionSignal = {
    create: (input) => {
        return hilPackageFunctionSignalSchema.parse(input);
    },
    merge: (existing, incoming) => ({
        optional: (0, merge_values_js_1.mergeValues)(existing.optional, incoming.optional),
        isMultiAssignment: (0, merge_values_js_1.mergeValues)(existing.isMultiAssignment, incoming.isMultiAssignment),
        busType: (0, merge_values_js_1.mergeValues)(existing.busType, incoming.busType),
        signalTypes: (0, merge_values_js_1.mergeValues)(existing.signalTypes, incoming.signalTypes),
        signalIds: (0, merge_values_js_1.mergeValues)(existing.signalIds, incoming.signalIds),
        description: (0, merge_values_js_1.mergeValues)(existing.description, incoming.description),
        classSignalDescription: (0, merge_values_js_1.mergeValues)(existing.classSignalDescription, incoming.classSignalDescription),
        alternateNames: (0, merge_values_js_1.mergeValues)(existing.alternateNames, incoming.alternateNames),
        maxAssignments: (0, merge_values_js_1.mergeValues)(existing.maxAssignments, incoming.maxAssignments),
    }),
    schema: hilPackageFunctionSignalSchema,
    dtoSchema: hilPackageFunctionSignalDtoSchema,
};
//# sourceMappingURL=hil-package-function-signal.js.map